import { getLayer, updateMapboxLayer } from 'ol-mapbox-style';
import { computed, ref, watch } from 'vue';
import { map, mapReady, mapView } from './useMap';
import { topics } from './useTopics';

/** @type {import('vue').Ref<Array<string>>} */
const baseLayers = ref([]);

/** @type {import('vue').Ref<string>} */
const baseLayer = ref();

/** @type {import('vue').Ref<number>} */
const opacity = ref(0.7);

/** @type {import('vue').ComputedRef<0|1>} */
const autoBaseLayerIndex = computed(() => (mapView.value.zoom > 14 ? 1 : 0));

function setLayerOpacity(mapboxLayer) {
  if (mapboxLayer.metadata?.group !== 'base') {
    if (mapboxLayer.type !== 'raster') {
      mapboxLayer.paint = { ...mapboxLayer.paint, 'raster-opacity': opacity.value };
      updateMapboxLayer(map, mapboxLayer);
    }
    getLayer(map, mapboxLayer.id).setOpacity(opacity.value);
  }
}

mapReady.then(() => {
  const { layers } = map.get('mapbox-style');
  baseLayers.value = [...layers.filter((l) => l.metadata?.group === 'base').map((l) => l.id), 'Kataster'];
  baseLayer.value = baseLayers.value[autoBaseLayerIndex.value];
  layers.forEach(setLayerOpacity);
});

let userModified = false;
watch(baseLayer, (value) => {
  map.getLayers().item(0).setVisible(value === 'Kataster');
  const { layers } = map.get('mapbox-style');
  layers.forEach((layer) => {
    if (layer.metadata?.group === 'base') {
      getLayer(map, layer.id).setVisible(layer.id === value);
    }
  });
  userModified = baseLayers.value.indexOf(value) !== autoBaseLayerIndex.value;
});

watch(() => mapView.value.zoom, (zoom) => {
  if (zoom <= 14 && baseLayer.value === 'Kataster') {
    baseLayer.value = baseLayers.value[autoBaseLayerIndex.value];
  }
});

watch(opacity, () => {
  const { layers } = map.get('mapbox-style');
  layers.forEach(setLayerOpacity);
});

watch(autoBaseLayerIndex, () => {
  if (!userModified) {
    baseLayer.value = baseLayers.value[autoBaseLayerIndex.value];
  }
});

watch(topics, (value) => {
  const { layers } = map.get('mapbox-style');
  const one = layers.filter((layer) => layer.metadata?.group === 'one' && layer.type !== 'raster');
  one.forEach((layer) => {
    const topic = value.find((v) => v.label === layer.metadata?.label);
    if (!topic) return;
    layer.layout = { ...layer.layout, visibility: topic.visible ? 'visible' : 'none' };
    updateMapboxLayer(map, layer);
  });
});

export function useLayers() {
  return {
    baseLayers, baseLayer, opacity,
  };
}
